import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';

@Component({
  standalone: false,
  selector: 'app-advanced-mode',
  templateUrl: './advanced-mode.component.html',
  styleUrls: ['./advanced-mode.component.scss']
})
export class AdvancedModeComponent implements OnInit
{
  /**
   * Title key to use for the text.
   */
  @Input() public titleKey = 'ADVANCED';

  /**
   * Unique storage key for saving the advance mode to local storage.
   */
  @Input() public storageKey: string;

  /**
   * Event emitter when when switch changes
   */
  @Output() public collapsibleToggle = new EventEmitter<boolean>();

  /**
   * Track if advanced mode is enabled.
   */
  public advancedMode: boolean;

  /**
   * Storage prefix
   */
  private storagePrefix = 'advanced-mode-';

  /**
   * Constructor
   */
  constructor(private storageService: LocalStorageService) { }

  public ngOnInit(): void
  {
    const enabled = this.storageKey !== undefined ? this.storageService.retrieve(`${this.storagePrefix}${this.storageKey}`) : null;
    this.advancedMode = enabled || false;
    this.collapsibleToggle.emit(this.advancedMode);
  }

  /**
   * Event handler when the switch has changed.
   *
   * @param newValue New switch value.
   */
  public onChange(newValue: boolean): void
  {
    this.advancedMode = newValue;
    if (this.storageKey !== undefined)
    {
      this.storageService.store(`${this.storagePrefix}${this.storageKey}`, this.advancedMode);
    }
    this.collapsibleToggle.emit(this.advancedMode);
  }
}
